import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import TransparentBlogCard from "reusables/Cards/BlogCards/TransparentBlogCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import homeOwner from "assets/images/Services/Construction/homeOwner.jpg";
import contractor from "assets/images/Services/Construction/contractor.jpg";
import realEstateAgent from "assets/images/Services/Construction/realEstateAgent.jpg";

function PostConstruction_Section4() {
  return (
    <Container>
      <SubTitleContents
        title="Who Can Benefit from Our Post-Construction Cleaning Services?"
        contents=""
      />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard
            image={homeOwner}
            title="Homeowners"
            description="After renovations or new builds."
            action={{
              // type: "internal",
              // route: "/",
              color: "info",
              label: "",
            }}
            // popular={true}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard
            image={contractor}
            title="Contractors"
            description="Prepare properties for handover to clients."
            // action={{
            //   type: "internal",
            //   route: "/",
            //   color: "info",
            //   label: "",
            // }}
            // popular={false}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard
            image={realEstateAgent}
            title="Real Estate Agents"
            description="Showcase homes in pristine condition."
            action={{
              type: "internal",
              // route: "/",
              color: "info",
              label: "hahaha",
            }}
            // popular={false}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default PostConstruction_Section4;
